import { render, staticRenderFns } from "./leadsDashboardLeadsDeprecated.vue?vue&type=template&id=36845c20&scoped=true"
import script from "./leadsDashboardLeadsDeprecated.vue?vue&type=script&lang=js"
export * from "./leadsDashboardLeadsDeprecated.vue?vue&type=script&lang=js"
import style0 from "./leadsDashboardLeadsDeprecated.vue?vue&type=style&index=0&id=36845c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36845c20",
  null
  
)

export default component.exports